module.exports = __webpack_public_path__ + "static/media/apng_weak_red.60b7c5bd.png";